import { uid } from './whiteboardShapes';

// Neutral, fully editable starter: every piece is an independent object.
export function icebergStarter() {
  return [
    { id: uid(), type: 'path', closed: true, fill: '#E0F2FE', stroke: '#94A3B8', strokeWidth: 2, opacity: 1,
      points: [[360, 250], [600, 250], [670, 360], [630, 500], [480, 560], [350, 490], [320, 360]] },
    { id: uid(), type: 'path', closed: true, fill: '#F8FAFC', stroke: '#94A3B8', strokeWidth: 2, opacity: 1,
      points: [[400, 250], [450, 170], [490, 120], [530, 150], [565, 205], [590, 250]] },
    { id: uid(), type: 'rect', x: 0, y: 250, w: 1000, h: 350, fill: '#3B82F6', stroke: '', strokeWidth: 0, opacity: 0.22 },
    { id: uid(), type: 'line', x1: 0, y1: 250, x2: 1000, y2: 250, stroke: '#1D4ED8', strokeWidth: 3, opacity: 0.8 },
    { id: uid(), type: 'text', x: 660, y: 140, text: 'What is visible', fontSize: 28, color: '#0F172A', opacity: 1, bold: true },
    { id: uid(), type: 'arrow', x1: 655, y1: 160, x2: 570, y2: 185, stroke: '#0F172A', strokeWidth: 2.5, opacity: 1 },
    { id: uid(), type: 'text', x: 700, y: 400, text: 'What lies beneath', fontSize: 28, color: '#0F172A', opacity: 1, bold: true },
    { id: uid(), type: 'arrow', x1: 695, y1: 420, x2: 640, y2: 430, stroke: '#0F172A', strokeWidth: 2.5, opacity: 1 },
    { id: uid(), type: 'text', x: 40, y: 270, text: 'Surface', fontSize: 20, color: '#1D4ED8', opacity: 0.9 },
  ];
}
